import { Usuario } from "eddydata-lib";
import { BaseResourceModel } from "../../models/base-resource.model";
import { AssinaturaEtapaPerfil } from "./assinatura-etapa-perfil.model";

export class PendenciaAssinatura extends BaseResourceModel {
    constructor(
        public id?: number,
        public id_entidade?: number,
        public id_storage?: number,
        public data_assinatura?: Date,
        public aceito?: boolean,
        public motivo?: string,
        public descricao?: string,
        public usuario_assinatura?: Usuario,
        public status?: string,
        public codigo_verificador?: string,
        public etapa?: AssinaturaEtapaPerfil,
        public parente?: PendenciaAssinatura,
    ) {
        super();
    }

    static converteJson(json: any): PendenciaAssinatura {
        return Object.assign(new PendenciaAssinatura(), json);
    }
}
